import script from "./ProfessionalismScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfessionalismScreen.vue?vue&type=script&setup=true&lang=js"

import "./ProfessionalismScreen.vue?vue&type=style&index=0&id=e179288a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e179288a"]])

export default __exports__